import React from 'react';

const SettingsPage = () => {
  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-600 mt-1">Manage social media integrations</p>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Social Media Integrations</h2>
          <p className="text-sm text-gray-500 mt-1">Connect your social media accounts for automatic posting</p>
        </div>

        <div className="p-6 space-y-4">
          {/* Facebook & Instagram (info only) */}
          <div className="border border-gray-200 rounded-lg p-4">
            <div className="flex items-center gap-3">
              <img src="/facebook.png" alt="Facebook" className="w-8 h-8" />
              <div>
                <h3 className="font-medium text-gray-900">Facebook & Instagram</h3>
                <p className="text-sm text-gray-500">Configured via environment variables (FACEBOOK_PAGE_ACCESS_TOKEN, FACEBOOK_PAGE_ID, INSTAGRAM_ACCOUNT_ID)</p>
              </div>
            </div>
          </div>

          {/* TikTok (info only) */}
          <div className="border border-gray-200 rounded-lg p-4">
            <div className="flex items-center gap-3">
              <img src="/tiktok.png" alt="TikTok" className="w-8 h-8" />
              <div>
                <h3 className="font-medium text-gray-900">TikTok</h3>
                <p className="text-sm text-gray-500">Configured via environment variables (TIKTOK_CLIENT_KEY, TIKTOK_CLIENT_SECRET). Users can share individual submissions to their own TikTok account from the Submissions page.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
